export enum EmployeesOverviewView {
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    QUARTER = 'quarter'
}
